import { Box, LinearProgress } from '@mui/material';
import zeplinColor from 'theme/Color';

const LinearProgressBarWithDot = ({ value, color }: { value: number; color: string }) => {
  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <LinearProgress
        variant='determinate'
        value={value}
        sx={{
          minWidth: '160px',
          height: 10,
          borderRadius: 5,
          backgroundColor: zeplinColor.Neutral4,
          '& .MuiLinearProgress-bar': {
            borderRadius: 5,
            backgroundColor: color,
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: `calc(${value}% - 6px)`,
          transform: 'translateY(-50%)',
          width: 16,
          height: 16,
          borderRadius: '50%',
          backgroundColor: zeplinColor.BasicBlack,
        }}
      />
    </Box>
  );
};

export default LinearProgressBarWithDot;
